var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "ask-contact-form bg-white rounded-[10px] px-5 py-5 sm:px-7 sm:py-6 border border-[#E2E2E2]"
    },
    [
      !_vm.sent
        ? _c(
            "form",
            {
              ref: "form",
              staticClass: "flex flex-col gap-3 pb-2",
              attrs: { method: "POST", action: _vm.action, novalidate: "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.onSubmit($event)
                }
              }
            },
            [
              _vm._l(_vm.textFields, function(field) {
                return _c("div", { key: field.name }, [
                  field.type === "checkbox"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.formData[field.name],
                            expression: "formData[field.name]"
                          }
                        ],
                        staticClass: "ac-control",
                        class: { "ac-invalid": !!_vm.errors[field.name] },
                        attrs: {
                          name: field.name,
                          autocomplete: field.autocomplete,
                          placeholder: _vm.$t(
                            "ask-contact.fields." + field.name
                          ),
                          "aria-label": _vm.$t(
                            "ask-contact.fields." + field.name
                          ),
                          disabled: _vm.submitting,
                          required: "",
                          type: "checkbox"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.formData[field.name])
                            ? _vm._i(_vm.formData[field.name], null) > -1
                            : _vm.formData[field.name]
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.formData[field.name],
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.formData,
                                    field.name,
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.formData,
                                    field.name,
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.formData, field.name, $$c)
                            }
                          }
                        }
                      })
                    : field.type === "radio"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.formData[field.name],
                            expression: "formData[field.name]"
                          }
                        ],
                        staticClass: "ac-control",
                        class: { "ac-invalid": !!_vm.errors[field.name] },
                        attrs: {
                          name: field.name,
                          autocomplete: field.autocomplete,
                          placeholder: _vm.$t(
                            "ask-contact.fields." + field.name
                          ),
                          "aria-label": _vm.$t(
                            "ask-contact.fields." + field.name
                          ),
                          disabled: _vm.submitting,
                          required: "",
                          type: "radio"
                        },
                        domProps: {
                          checked: _vm._q(_vm.formData[field.name], null)
                        },
                        on: {
                          change: function($event) {
                            _vm.$set(_vm.formData, field.name, null)
                          }
                        }
                      })
                    : _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.formData[field.name],
                            expression: "formData[field.name]"
                          }
                        ],
                        staticClass: "ac-control",
                        class: { "ac-invalid": !!_vm.errors[field.name] },
                        attrs: {
                          name: field.name,
                          autocomplete: field.autocomplete,
                          placeholder: _vm.$t(
                            "ask-contact.fields." + field.name
                          ),
                          "aria-label": _vm.$t(
                            "ask-contact.fields." + field.name
                          ),
                          disabled: _vm.submitting,
                          required: "",
                          type: field.type
                        },
                        domProps: { value: _vm.formData[field.name] },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.formData,
                              field.name,
                              $event.target.value
                            )
                          }
                        }
                      }),
                  _vm._v(" "),
                  _vm.errors[field.name]
                    ? _c("p", { staticClass: "ac-error" }, [
                        _vm._v(_vm._s(_vm.errors[field.name][0]))
                      ])
                    : _vm._e()
                ])
              }),
              _vm._v(" "),
              _c("phone-field", {
                class: { "ac-invalid": !!_vm.errors.phone },
                attrs: {
                  name: "phone",
                  errors: _vm.errors.phone,
                  label: _vm.$t("ask-contact.fields.phone"),
                  "show-label": false,
                  "country-id": _vm.countryId,
                  disabled: _vm.submitting ? "disabled" : null,
                  required: "",
                  "new-version": ""
                },
                model: {
                  value: _vm.formData.phone,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "phone", $$v)
                  },
                  expression: "formData.phone"
                }
              }),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass: "text-base text-[#273B64] mt-1",
                  attrs: { id: "ask-contact-meeting-type" }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("ask-contact.fields.meeting_type")) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "flex gap-2",
                  attrs: {
                    role: "radiogroup",
                    "aria-labelledby": "ask-contact-meeting-type"
                  }
                },
                _vm._l(_vm.meetingTypes, function(type) {
                  return _c(
                    "button",
                    {
                      key: type,
                      staticClass: "ac-choice",
                      class: {
                        "is-selected": _vm.formData.meeting_type === type
                      },
                      attrs: {
                        type: "button",
                        role: "radio",
                        "aria-checked":
                          _vm.formData.meeting_type === type ? "true" : "false",
                        disabled: _vm.submitting
                      },
                      on: {
                        click: function($event) {
                          _vm.formData.meeting_type = type
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("ask-contact.meeting-types." + type)) +
                          "\n            "
                      )
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm.errors.meeting_type
                ? _c("p", { staticClass: "ac-error" }, [
                    _vm._v(_vm._s(_vm.errors.meeting_type[0]))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "grid grid-cols-1 sm:grid-cols-2 gap-3 items-start"
                },
                [
                  _c("div", { ref: "datePicker", staticClass: "relative" }, [
                    _c(
                      "button",
                      {
                        staticClass: "ac-control ac-trigger",
                        class: { "ac-invalid": !!_vm.errors.date },
                        attrs: {
                          type: "button",
                          "aria-expanded": _vm.dateOpen ? "true" : "false",
                          disabled: _vm.submitting
                        },
                        on: { click: _vm.toggleDate }
                      },
                      [
                        _vm.formData.date
                          ? _c("span", { staticClass: "text-[#273B64]" }, [
                              _vm._v(_vm._s(_vm.dateLabel))
                            ])
                          : _c("span", { staticClass: "text-[#989898]" }, [
                              _vm._v(_vm._s(_vm.$t("ask-contact.fields.date")))
                            ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-[#00A07F]" }, [
                          _c(
                            "svg",
                            {
                              staticClass:
                                "inline-block shrink-0 align-[-0.125em]",
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "1em",
                                height: "1em",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "aria-hidden": "true"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d:
                                    "M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z"
                                }
                              }),
                              _c("path", { attrs: { d: "M16 3v4" } }),
                              _c("path", { attrs: { d: "M8 3v4" } }),
                              _c("path", { attrs: { d: "M4 11h16" } })
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.errors.date
                      ? _c("p", { staticClass: "ac-error" }, [
                          _vm._v(_vm._s(_vm.errors.date[0]))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dateOpen
                      ? _c("div", { staticClass: "ac-popover" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center justify-between mb-2 text-[15px]"
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "ac-nav",
                                  attrs: {
                                    type: "button",
                                    disabled: !_vm.canGoBack,
                                    "aria-label": _vm.$t(
                                      "ask-contact.calendar.previous-month"
                                    )
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.shiftMonth(-1)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "inline-block shrink-0 align-[-0.125em]",
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "1em",
                                        height: "1em",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        "stroke-width": "2",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "aria-hidden": "true"
                                      }
                                    },
                                    [
                                      _c("path", {
                                        attrs: { d: "M15 6l-6 6l6 6" }
                                      })
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("strong", { staticClass: "font-semibold" }, [
                                _vm._v(_vm._s(_vm.monthLabel))
                              ]),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "ac-nav",
                                  attrs: {
                                    type: "button",
                                    "aria-label": _vm.$t(
                                      "ask-contact.calendar.next-month"
                                    )
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.shiftMonth(1)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "inline-block shrink-0 align-[-0.125em]",
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "1em",
                                        height: "1em",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        "stroke-width": "2",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "aria-hidden": "true"
                                      }
                                    },
                                    [
                                      _c("path", {
                                        attrs: { d: "M9 6l6 6l-6 6" }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "grid grid-cols-7 gap-0.5 mb-1" },
                            _vm._l(_vm.weekdayInitials, function(
                              initial,
                              index
                            ) {
                              return _c(
                                "span",
                                {
                                  key: index,
                                  staticClass:
                                    "text-center text-[12px] font-semibold",
                                  class:
                                    index >= 5
                                      ? "text-[#C2C2C2]"
                                      : "text-[#989898]"
                                },
                                [_vm._v(_vm._s(initial))]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "grid grid-cols-7 gap-0.5 text-[14px] tabular-nums"
                            },
                            [
                              _vm._l(_vm.days, function(day, index) {
                                return [
                                  day.blank
                                    ? _c("span", { key: "blank-" + index })
                                    : day.off
                                    ? _c(
                                        "span",
                                        {
                                          key: day.value,
                                          staticClass:
                                            "h-8 flex items-center justify-center rounded-full text-[#C2C2C2] bg-[#F5F5F5] line-through"
                                        },
                                        [_vm._v(_vm._s(day.n))]
                                      )
                                    : _c(
                                        "button",
                                        {
                                          key: day.value,
                                          staticClass:
                                            "ac-day h-8 flex items-center justify-center rounded-full",
                                          class:
                                            day.value === _vm.formData.date
                                              ? "bg-[#00A07F] text-white font-semibold"
                                              : "text-[#273B64] hover:bg-[#E6F5F1]",
                                          attrs: {
                                            type: "button",
                                            "aria-pressed":
                                              day.value === _vm.formData.date
                                                ? "true"
                                                : "false"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.pickDate(day.value)
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(day.n))]
                                      )
                                ]
                              })
                            ],
                            2
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { ref: "timePicker", staticClass: "relative" }, [
                    _c(
                      "button",
                      {
                        staticClass: "ac-control ac-trigger",
                        class: { "ac-invalid": !!_vm.errors.time },
                        attrs: {
                          type: "button",
                          "aria-expanded": _vm.timeOpen ? "true" : "false",
                          disabled: _vm.submitting
                        },
                        on: { click: _vm.toggleTime }
                      },
                      [
                        _vm.formData.time
                          ? _c("span", { staticClass: "text-[#273B64]" }, [
                              _vm._v(_vm._s(_vm.timeLabel))
                            ])
                          : _c("span", { staticClass: "text-[#989898]" }, [
                              _vm._v(_vm._s(_vm.$t("ask-contact.fields.time")))
                            ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-[#00A07F]" }, [
                          _c(
                            "svg",
                            {
                              staticClass:
                                "inline-block shrink-0 align-[-0.125em]",
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "1em",
                                height: "1em",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "aria-hidden": "true"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"
                                }
                              }),
                              _c("path", { attrs: { d: "M12 7v5l3 3" } })
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.errors.time
                      ? _c("p", { staticClass: "ac-error" }, [
                          _vm._v(_vm._s(_vm.errors.time[0]))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.timeOpen
                      ? _c("div", { staticClass: "ac-popover" }, [
                          _c(
                            "p",
                            { staticClass: "text-[13px] text-[#989898] mb-2" },
                            [_vm._v(_vm._s(_vm.$t("ask-contact.time-hint")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "grid grid-cols-3 gap-1.5 tabular-nums"
                            },
                            [
                              _vm._l(_vm.timeSlots, function(slot) {
                                return [
                                  !slot.available
                                    ? _c(
                                        "span",
                                        {
                                          key: slot.value,
                                          staticClass:
                                            "py-1.5 text-center rounded-md bg-[#F5F5F5] text-[#C2C2C2] text-[14px] line-through"
                                        },
                                        [_vm._v(_vm._s(slot.label))]
                                      )
                                    : _c(
                                        "button",
                                        {
                                          key: slot.value,
                                          staticClass:
                                            "ac-slot py-1.5 text-center rounded-md text-[14px]",
                                          class:
                                            slot.value === _vm.formData.time
                                              ? "bg-[#00A07F] text-white font-semibold border border-[#00A07F]"
                                              : "border border-[#E2E2E2] text-[#273B64] hover:border-[#00A07F]",
                                          attrs: {
                                            type: "button",
                                            "aria-pressed":
                                              slot.value === _vm.formData.time
                                                ? "true"
                                                : "false"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.pickTime(slot.value)
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(slot.label))]
                                      )
                                ]
                              })
                            ],
                            2
                          )
                        ])
                      : _vm._e()
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.needs,
                      expression: "formData.needs"
                    }
                  ],
                  staticClass: "ac-control ac-textarea",
                  class: { "ac-invalid": !!_vm.errors.needs },
                  attrs: {
                    name: "needs",
                    rows: "3",
                    placeholder: _vm.$t("ask-contact.placeholders.needs"),
                    "aria-label": _vm.$t("ask-contact.fields.needs"),
                    disabled: _vm.submitting
                  },
                  domProps: { value: _vm.formData.needs },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.formData, "needs", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _vm.errors.needs
                  ? _c("p", { staticClass: "ac-error" }, [
                      _vm._v(_vm._s(_vm.errors.needs[0]))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "text-[15px] text-[#6b7891] text-center mt-1" },
                [_vm._v(_vm._s(_vm.$t("ask-contact.notice")))]
              ),
              _vm._v(" "),
              _vm.genericError
                ? _c(
                    "p",
                    {
                      staticClass: "ac-error text-center",
                      attrs: { role: "alert" }
                    },
                    [_vm._v(_vm._s(_vm.genericError))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "ac-submit",
                  attrs: { type: "submit", disabled: _vm.submitting }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.submitting
                          ? _vm.$t("ask-contact.submitting")
                          : _vm.$t("ask-contact.submit")
                      ) +
                      "\n        "
                  )
                ]
              )
            ],
            2
          )
        : _c(
            "div",
            {
              staticClass: "flex flex-col items-center text-center gap-3 py-6",
              attrs: { role: "status" }
            },
            [
              _c("span", { staticClass: "text-[#00A07F] text-[40px]" }, [
                _c(
                  "svg",
                  {
                    staticClass: "inline-block",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "1em",
                      height: "1em",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "aria-hidden": "true"
                    }
                  },
                  [
                    _c("path", {
                      attrs: { d: "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" }
                    }),
                    _c("path", { attrs: { d: "M9 12l2 2l4 -4" } })
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "h2",
                { staticClass: "text-[22px] font-semibold text-[#273B64]" },
                [_vm._v(_vm._s(_vm.$t("ask-contact.sent.title")))]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "text-[17px] text-[#4a5a7a]" }, [
                _vm._v(
                  _vm._s(_vm.$t("ask-contact.sent.content", _vm.sentSummary))
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "w-full flex flex-col items-center gap-3 mt-3 pt-5 border-t border-[#E2E2E2]"
                },
                [
                  _c("p", { staticClass: "text-[17px] text-[#273B64]" }, [
                    _vm._v(_vm._s(_vm.$t("ask-contact.sent.meanwhile")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "ac-submit ac-register",
                      attrs: { href: _vm.registrationUrl }
                    },
                    [_vm._v(_vm._s(_vm.$t("ask-contact.sent.simulate")))]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                { staticClass: "ac-back", attrs: { href: _vm.continueUrl } },
                [_vm._v(_vm._s(_vm.$t("ask-contact.sent.back")))]
              )
            ]
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74a0358b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74a0358b","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/AskContactFormComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-74a0358b","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/AskContactFormComponent.vue
// module chunks = 1 2 3